import { ShieldCheck, ShieldAlert, ShieldX, Loader2, Clock } from "lucide-react";

const STATUS_MAP = {
  invitation_sent: {
    label: "Invite sent",
    cls: "border-slate-200 bg-slate-50 text-slate-700",
    icon: Clock,
  },
  pending: {
    label: "Pending",
    cls: "border-slate-200 bg-slate-50 text-slate-700",
    icon: Clock,
  },
  in_progress: {
    label: "In progress",
    cls: "border-blue-200 bg-blue-50 text-blue-700",
    icon: Loader2,
  },
  consider: {
    label: "Consider",
    cls: "border-amber-200 bg-amber-50 text-amber-800",
    icon: ShieldAlert,
  },
  clear: {
    label: "Clear",
    cls: "border-emerald-200 bg-emerald-50 text-emerald-700",
    icon: ShieldCheck,
  },
  suspended: {
    label: "Suspended",
    cls: "border-rose-200 bg-rose-50 text-rose-700",
    icon: ShieldX,
  },
  canceled: {
    label: "Canceled",
    cls: "border-slate-200 bg-slate-50 text-slate-500",
    icon: ShieldX,
  },
  completed: {
    label: "Completed",
    cls: "border-emerald-200 bg-emerald-50 text-emerald-700",
    icon: ShieldCheck,
  },
};

export default function BackgroundCheckBadge({ status, assessment, className = "" }) {
  if (!status) return null;
  // Assessment overrides status for the visual: a Consider beats Pending
  const key = assessment || status;
  const meta = STATUS_MAP[key] || STATUS_MAP[status] || STATUS_MAP.pending;
  const Icon = meta.icon;
  return (
    <span
      data-testid={`bg-badge-${key}`}
      className={`inline-flex items-center gap-1 border px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wider ${meta.cls} ${className}`}
      title={`Background check: ${meta.label}`}
    >
      <Icon className={`h-3 w-3 ${key === "in_progress" ? "animate-spin" : ""}`} />
      BG · {meta.label}
    </span>
  );
}
